import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { LinkButton, Text } from '@/style-guide'
import { CopyIcon } from '@/style-guide'
import moment from 'moment'
import { Button, Popover, Switch, Tag, Typography } from 'antd'
import { Loader } from '../Loader'
import { getSelectedTrips, getSelectedHosts } from '@/utils/apiEndpoints'
import { TripPicture } from '../TripPicture'
import { ProfilePicture } from '../ProfilePicture'

export const TripPlaceHolder = styled.div`
  display: block;
  background-color: #d1d1d1;
  width: 100%;
  height: 250px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
`
const ApplicableText = ({ couponCode }) => {
  const [selectedTrips, setSelectedTrips] = useState(false)
  const [selectedHosts, setSelectedHosts] = useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (couponCode.applicableType === 'trips')
      fetchSelectedTrips(couponCode._id)
    if (couponCode.applicableType === 'hosts') getSelectedHosts(couponCode._id)
  }, [couponCode.specificValues])
  const fetchSelectedTrips = async () => {
    setLoading(true)
    try {
      const res = await getSelectedTrips(couponCode._id)
      setSelectedTrips(res.result)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  const handleSelectedTripsHoverChange = (value) => {
    if (value) {
      !selectedTrips && fetchSelectedTrips()
    }
  }
  const fetchSelectedHosts = async () => {
    setLoading(true)
    try {
      const res = await getSelectedHosts(couponCode._id)
      setSelectedHosts(res.result)
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  const handleSelectedHostsHoverChange = (value) => {
    if (value) {
      !selectedHosts && fetchSelectedHosts()
    }
  }
  const CommonText = () => {
    return <>Applies to: </>
  }

  switch (couponCode.applicableType) {
    case 'site_wide':
      return (
        <>
          <CommonText />
          <Popover
            content={
              'All the events avaialble in Tripsha applicable to avail this code'
            }
            title="All Tripsha events"
          >
            <Button type="link">All Tripsha events</Button>
          </Popover>
        </>
      )
    case 'hosts':
      const hosts = (
        <Loader loading={loading} style={{ minHeight: '100px' }}>
          <div className="tag-container">
            {selectedHosts &&
              selectedHosts.map((host) => (
                <Tag key={host._id}>
                  <ProfilePicture user={host} size={40} />
                  <Text className="tag-text">
                    <Text weight="700" size={16}>
                      {host.firstName} {host.lastName}
                    </Text>
                    <Text>
                      {host.firstName && host.lastName ? 
                        `${host.firstName} ${host.lastName}` : 
                        host.email || host.username}
                    </Text>
                  </Text>
                </Tag>
              ))}
          </div>
        </Loader>
      )
      return (
        <>
          <CommonText />
          <Popover
            content={<div className="applicable-text-tooltip">{hosts}</div>}
            title="Selected hosts"
            onOpenChange={handleSelectedHostsHoverChange}
          >
            <Button type="link">Selected hosts</Button>
          </Popover>
        </>
      )
    case 'my_trips':
      return (
        <>
          <CommonText />
                      <Popover
              content={
                "All events listed under 'Active events' on your dashboard, including events that become active after the creation of this code."
              }
              title="All my events"
            >
            <Button type="link">Selected events</Button>
          </Popover>
        </>
      )
    case 'trips':
      const trips = (
        <Loader loading={loading} style={{ minHeight: '100px' }}>
          <div className="tag-container">
            {selectedTrips &&
              selectedTrips.map((trip) => (
                <Tag key={trip._id}>
                  <TripPicture
                    trip={trip}
                    height="60px"
                    width="60px"
                    preview={false}
                    style={{ borderRadius: '5px' }}
                  />
                  <Text className="tag-text">
                    <Text weight="700" size={16}>
                      {trip.title}
                    </Text>
                    <Text size={11}>
                      {moment(trip.startDate, 'YYYYMMDD').format('L')} ~{' '}
                      {moment(trip.endDate, 'YYYYMMDD').format('L')}
                    </Text>

                    <Text
                      weight="700"
                      color={
                        trip.isArchived
                          ? 'red-color'
                          : trip.status === 'draft'
                            ? 'grey'
                            : 'green-color'
                      }
                    >
                      {trip.isArchived
                        ? 'Archived'
                        : trip.status === 'draft'
                          ? 'Draft'
                          : 'Active'}
                    </Text>
                  </Text>
                </Tag>
              ))}
          </div>
        </Loader>
      )
      return (
        <>
          <CommonText />
          <Popover
            content={<div className="applicable-text-tooltip">{trips}</div>}
            title="Selected events"
            onOpenChange={handleSelectedTripsHoverChange}
          >
            <Button type="link">Selected events</Button>
          </Popover>
        </>
      )
    case 'countries':
      const selectedCountries = (
        <>
          {couponCode.specificValues.map((tag, ind) => (
            <Tag key={tag + ind}>
              <Text weight="700">{tag}</Text>
            </Tag>
          ))}
        </>
      )
      return (
        <>
          <CommonText />
          <Popover content={selectedCountries} title="Selected countries">
            <Button type="link">Selected countries</Button>
          </Popover>
        </>
      )
    case 'tags':
      const selectedTags = couponCode.specificValues.map((tag, ind) => (
        <Tag key={tag + ind}>
          <Text weight="700">{tag}</Text>
        </Tag>
      ))
      return (
        <>
          <CommonText />
          <Popover content={selectedTags} title="Selected tags">
            <Button type="link">Selected tags</Button>
          </Popover>
        </>
      )
    default:
      return ''
  }
}

export const CouponCodeCard = ({
  onEdit,
  onDelete,
  couponCode,
  onQuickAction,
}) => {
  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value)
  }
  let validity = 'Unlimited'
  let isValid = true
  if (couponCode && couponCode.expiryDate) {
    const expiryDate = moment(String(couponCode.expiryDate), 'YYYYMMDD')
    if (expiryDate.diff(moment()) < 0) isValid = false
    validity = expiryDate.format('MMM DD, YYYY')
  }

  return (
    <div className="attendee-card coupon-code">
      <div className="trip-content" style={{ textAlign: 'center' }}>
        <div className="applicable-text">
          <div className='discount-content'>
            {couponCode.discType === 'percentage'
              ? `${couponCode.amount}% `
              : `$${couponCode.amount} `}
            Discount
          </div>
          <div>
            {couponCode.isActive && isValid ?
              <div className='isActive-discount' style={{ backgroundColor: "#D9F7BE", color: "#237804" }} onClick={() => onQuickAction(couponCode, false)}>Active</div> :
              <div className='isActive-discount' style={{ backgroundColor: "#D53E29", color: "white" }} onClick={() => onQuickAction(couponCode, true)}>InActive</div>}
          </div>
        </div>
        <div className="copon-code-container">
          <Typography.Title level={4}>
            {couponCode.couponCode}
            <CopyIcon
              title="Copy code"
              onClick={() => copyToClipboard(couponCode.couponCode)}
            />
          </Typography.Title>
        </div>
        <div className='applicable-text-details-container'>
          <div className="applicable-text-details">
            Valid until:{' '}
            <Text weight="700" className={isValid ? 'green-color' : 'red-color'}>
              {validity}
            </Text>
          </div>
          <div className="applicable-text-details">
            <ApplicableText couponCode={couponCode} />
          </div>
        </div>
        <div className='buttons-container'>
          <div>
            <Button
              className="on-edit-button"
              onClick={() => onEdit(couponCode)}
              size="large"
              block
              type="primary"
            >
              Edit
            </Button>
          </div>
          <div className='delete-coupon-organization-button'>
            <Button
              size="large"
              type="link"
              danger
              onClick={() => onDelete(couponCode)}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
